import React from "react";


const DeleteIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="21" viewBox="0 0 19.5 21">
        <g id="recycle-bin-2--remove-delete-empty-bin-trash-garbage" transform="translate(-0.25 0.25)">
            <path id="Vector" d="M1,3.5H19" transform="translate(0 1.5)" fill="none" stroke="rgba(23,41,81,0.7)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            <path id="Vector_2" d="M2.5,3.5H16V17a1.5,1.5,0,0,1-1.5,1.5H4A1.5,1.5,0,0,1,2.5,17Z" transform="translate(0.75 1.5)" fill="none" stroke="rgba(23,41,81,0.7)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            <path id="Vector_3" d="M4.5,5V4.25a3.75,3.75,0,1,1,7.5,0V5" transform="translate(1.75)" fill="none" stroke="rgba(23,41,81,0.7)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            <path id="Vector_4" d="M5.5,6.5v6" transform="translate(2.25 3.001)" fill="none" stroke="rgba(23,41,81,0.7)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            <path id="Vector_5" d="M8.5,6.5v6" transform="translate(3.75 3.001)" fill="none" stroke="rgba(23,41,81,0.7)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
        </g>
        </svg>


    );

}

export default DeleteIcon;